
namespace GeniuzPOS.PosShift {
    import fld = PsPosMoneyCountRow.Fields;
    
    @Serenity.Decorators.registerClass()
    export class PsPosMoneyCountGrid extends Serenity.EntityGrid<PsPosMoneyCountRow, any> {
        protected getColumnsKey() { return PsPosMoneyCountColumns.columnsKey; }
        protected getDialogType() { return PsPosMoneyCountDialog; }
        protected getIdProperty() { return PsPosMoneyCountRow.idProperty; }
        protected getInsertPermission() { return PsPosMoneyCountRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPosMoneyCountRow.localTextPrefix; }
        protected getService() { return PsPosMoneyCountService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
			var button = super.getButtons();

            button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
            
            button.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PsPosMoneyCountService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
                
                button.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
			// button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
			return button;
		}
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            var createDateFilter = Q.first(filters, x => x.field == fld.CreateDate);
            if (createDateFilter) {
                createDateFilter.init = w => {
                    (w as Serenity.DateEditor).valueAsDate = new Date(new Date().setDate(new Date().getDate()-7));

                    let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                    endDate.valueAsDate = new Date(Date.now());
                };
            }

            return filters;
        }
    }
}